module.exports = __webpack_public_path__ + "img/AccessCRM.7033a3c4.svg";